var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-editor-container" },
    [
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 20 } },
        _vm._l(_vm.cardInfo, function(info, index) {
          return _c("CardInfo", {
            key: index,
            attrs: { loading: _vm.loading, info: info, cardKey: index }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 32 } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { xs: 24, sm: 24, lg: 24 }
            },
            [
              !_vm.loading
                ? _c(
                    "el-card",
                    {
                      staticClass:
                        "chart-wrapper enter-animation animationdelay-4s",
                      attrs: { role: "button", tabindex: "-1" }
                    },
                    [
                      _vm.sevenDaysNotEmpty
                        ? _c("line-chart", {
                            ref: "lineChart",
                            attrs: {
                              "chart-label": _vm.lineGraphLabel,
                              "chart-data": _vm.sevenDays,
                              "chart-title": _vm.$t("dashboard.lineChartTitle")
                            }
                          })
                        : _c("div", [
                            _c("div", { staticClass: "bar-title" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("dashboard.lineChartTitle")) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 32 } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { xs: 24, sm: 24, lg: 12 }
            },
            [
              !_vm.loading
                ? _c(
                    "el-card",
                    {
                      staticClass:
                        "chart-wrapper enter-animation animationdelay-5s",
                      attrs: { role: "button", tabindex: "-1" }
                    },
                    [
                      _vm.topRate.length
                        ? _c("bar-chart-horizontal", {
                            ref: "barChartHorizontal",
                            attrs: {
                              isPercent: true,
                              labels: _vm.topRateLabels,
                              values: _vm.topRatePercent,
                              placeholder: _vm.$t("dashboard.successRate"),
                              "chart-title": _vm.$t(
                                "dashboard.top5SuccessRate"
                              ),
                              "chart-subtitle": _vm.successDate
                            }
                          })
                        : _c("div", [
                            _c("div", { staticClass: "bar-title" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.top5SuccessRate"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { xs: 24, sm: 24, lg: 12 }
            },
            [
              !_vm.loading
                ? _c(
                    "el-card",
                    {
                      staticClass:
                        "chart-wrapper enter-animation animationdelay-6s",
                      attrs: { role: "button", tabindex: "-1" }
                    },
                    [
                      _vm.bottomRate.length
                        ? _c("bar-chart-horizontal", {
                            ref: "barChartHorizontal2",
                            attrs: {
                              isPercent: true,
                              labels: _vm.bottomRateLabels,
                              values: _vm.bottomRatePercent,
                              placeholder: _vm.$t("dashboard.failureRate"),
                              "chart-title": _vm.$t(
                                "dashboard.top5FailureRate"
                              ),
                              "chart-subtitle": _vm.failDate,
                              "type-success": false
                            }
                          })
                        : _c("div", [
                            _c("div", { staticClass: "bar-title" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.top5FailureRate"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 32 } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { xs: 24, sm: 24, lg: 24 }
            },
            [
              !_vm.loading
                ? _c(
                    "el-card",
                    {
                      staticClass:
                        "chart-wrapper enter-animation animationdelay-7s",
                      attrs: { role: "button", tabindex: "-1" }
                    },
                    [
                      _vm.channelLabels.length
                        ? _c("bar-chart", {
                            ref: "barChart",
                            attrs: {
                              isPercent: true,
                              labels: _vm.channelLabels,
                              values: _vm.channelValues,
                              placeholder: _vm.$t("dashboard.successRate"),
                              "chart-title": _vm.$t("dashboard.top6Channels"),
                              "chart-subtitle": _vm.channelDate
                            }
                          })
                        : _c("div", [
                            _c("div", { staticClass: "bar-title" }, [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("dashboard.top6Channels")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 32 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 12 } },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass:
                    "chart-wrapper top-10-list-card enter-animation animationdelay-8s",
                  attrs: { role: "button", tabindex: "-1" }
                },
                [_c("Top10List", { attrs: { mode: true, data: _vm.topOrgs } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 12 } },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass:
                    "chart-wrapper top-10-list-card  enter-animation animationdelay-9s",
                  attrs: { role: "button", tabindex: "-1" }
                },
                [
                  _c("Top10List", {
                    attrs: { mode: false, data: _vm.topAgents }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }